module.exports = __webpack_public_path__ + "media/images/emblems/Rorschab-8bbe14081bf020fabd8f584cf8dc1d69.png";